import React from 'react';
import styles from './styles.module.scss';

import ToggleBar from 'components/ToggleBars/ToggleBar';

import { TOGGLE_BUTTONS } from '../../helpers';

export function Tabs({ activeTab, setActiveTab }) {
  const clickTab = (tabValue) => tabValue && setActiveTab(tabValue);

  return (
    <div className={styles.tabs}>
      <ToggleBar
        buttons={TOGGLE_BUTTONS}
        onChange={clickTab}
        selectedTab={activeTab}
        classes={styles.tabs__bar}
      />
    </div>
  );
}
